import { fetcher } from 'utils/axios';

//* reset password
export const fetchSendOTPByPhone = async (phone: string) => {
  try {
    const data = await fetcher('get', `/api/auth/resendOTPByPhone/${phone}`, 'history', true);
    return data;
  } catch (error) {
    console.warn('Error fetching send OTP by phone:', error);
    return null;
  }
};
export const fetchVerifyOTP = async (phone: string, otp: string) => {
  const data = await fetcher(
    'post',
    [
      '/api/auth/VerifyOTPByPhoneNumber',
      {
        data: {
          PhoneNumber: phone,
          OTP: otp,
        },
      },
    ],
    'history',
    true,
  );

  return data as {
    success: boolean;
  } | null;
};
export const fetchResetPassword = async (phone: string, password: string, otp: string) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/auth/resetPasswordByPhoneNumber',
        {
          data: {
            phoneNumber: phone,
            Password: password,
            OTP: otp,
          },
        },
      ],
      'history',
      true,
    );

    return data as {
      result: boolean;
      message?: string;
    } | null;
  } catch (error) {
    console.warn('Error fetching reset password:', error);
    return null;
  }
};

//* register
export const fetchCheckPhoneNumberAvailable = async (phoneNumber: string) => {
  try {
    const data = await fetcher(
      'get',
      [
        '/api/auth/isPhoneNumberAvailable',
        {
          data: {
            phoneNumber,
          },
        },
      ],
      'history',
      true,
    );

    return data;
  } catch (error) {
    console.warn('Error checking phone number availability:', error);
    return null;
  }
};
export const fetchRegisterUserFBSignup = async (params: {
  Email: string;
  Password: string;
  PhoneNumber: string;
  FirstName: string;
  LastName: string;
  CompanyName: string;
  Standalone: boolean;
  signupData: any;
  testIsSuccess: boolean;
}) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/auth/registerUserFBSignup',
        {
          data: params,
        },
      ],
      'history',
      true,
    );
    return data;
  } catch (error) {
    console.warn('Error fetching FB signup URL:', error);
    return null;
  }
};

//* login
export const getFunnerUserServerContext = async (phone: string) => {
  try {
    const serverContextRes = await fetcher(
      'get',
      [
        '/api/services/getFunnerUserServerContext',
        {
          data: { PhoneNumber: phone },
          skipServerContext: true,
        },
      ],
      'newapi',
    );

    return serverContextRes;
  } catch (error) {
    console.warn('Error fetching server context:', error);
    return null;
  }
};
export const fetchLogin = async (phone: string, password: string) => {
  console.log('Login request:', phone, password);
  try {
    const res = await fetcher(
      'post',
      [
        '/api/auth/loginfunner',
        {
          data: { phone, password },
        },
      ],
      'history',
      true,
    );

    console.log('Login response:', res);
    return res as {
      success: boolean;
      data?: string;
      error?: 'otp_not_verified' | 'user_or_password_wrong';
    } | null;
  } catch (error) {
    console.warn('Error fetching login:', error);
    return null;
  }
};
export const fetchGetApplicationUserProfile = async () => {
  try {
    const res = await fetcher('get', '/api/auth/getApplicationUserProfile', 'history');
    return res;
  } catch (error) {
    console.warn('Error fetching application user profile:', error);
    return null;
  }
};
